export default __webpack_public_path__ + "static/Acta-Bold-bd5ba836dd5c308528342dd53df2e402.woff";